/**
 * Substitut navigateur des modules Node (`node:fs`, `node:path`).
 *
 * `@elemora/shared/content` exporte, à côté des schémas zod, le validateur de bundle qui lit des
 * fichiers JSON (`packages/content/data/*.json`). Le back-office n'en a pas besoin : il ne valide
 * que des objets déjà en mémoire, avec les mêmes schémas. Vite remplace donc ces deux modules par
 * ce fichier (voir `vite.config.ts`), qui **échoue bruyamment** si un appel oublie la règle
 * plutôt que de renvoyer une valeur inventée.
 */

/** Erreur levée si un code navigateur atteint une API de fichier. */
function interdit(nom: string): never {
  throw new Error(
    `${nom} n'est pas disponible dans le navigateur : le back-office valide des objets, ` +
      'il ne lit pas de fichiers (voir src/app/stub-node-navigateur.ts).',
  );
}

/** Aucun export nommé n'est utilisé : les appels passent par ce Proxy. */
const proxyInterdit: Record<string, unknown> = new Proxy(
  {},
  {
    get: (_cible, propriete) => () => interdit(String(propriete)),
  },
);

export const readFileSync = (): never => interdit('readFileSync');
export const existsSync = (): never => interdit('existsSync');
export const join = (): never => interdit('join');
export const resolve = (): never => interdit('resolve');
export const dirname = (): never => interdit('dirname');
export default proxyInterdit;
